import {LOCALE_ID, NgModule} from '@angular/core';
import {CommonModule, HashLocationStrategy, LocationStrategy} from '@angular/common';
import {HomeComponent} from '../modules/general/home/home.component';
import {WelcomeComponent} from '../components/welcome/welcome.component';
import {NgbDropdownModule, NgbModule, NgbNavModule} from '@ng-bootstrap/ng-bootstrap';
import {TranslateModule} from '@ngx-translate/core';
import {AffectationRetraitComponent} from '../components/affectation-retrait/affectation-retrait.component';
import {NgxPaginationModule} from 'ngx-pagination';
import {NgMetro4BaseModule, NgMetro4FormsModule} from 'ng-metro4';
import {BdcReglementsFactoryComponent} from '../components/bdc-reglements-factory/bdc-reglements-factory.component';
import {NgSelectModule} from '@ng-select/ng-select';
import {TableFactoryComponent} from '../components/table-factory/table-factory.component';
import {LeftSiteComponent} from '../components/left-site/left-site.component';


@NgModule({
  declarations: [
    HomeComponent,
    WelcomeComponent,
    AffectationRetraitComponent,
    BdcReglementsFactoryComponent,
    TableFactoryComponent,
    LeftSiteComponent
  ],
  imports: [
    CommonModule,
    NgbNavModule,
    NgbDropdownModule,
    NgbModule,
    TranslateModule,
    NgxPaginationModule,
    NgMetro4FormsModule,
    NgMetro4BaseModule,
    NgSelectModule
  ],
  exports: [
    WelcomeComponent,
    BdcReglementsFactoryComponent,
    TableFactoryComponent,
    LeftSiteComponent
  ],
  entryComponents: [
    AffectationRetraitComponent
  ],
  providers: [
    { provide: LOCALE_ID, useValue: 'en'},
    { provide: LocationStrategy, useClass: HashLocationStrategy}
  ]
})
export class SharedModule { }
